import { SchoolOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { useTrainingMaterialTitleFormatter } from '@tabeeb/shared/utils/text'
import { getIsTrainingMaterialsEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const TrainingMaterialsTab: React.FC = () => {
  const { f } = useTrainingMaterialTitleFormatter()

  const display = useSelector(getIsTrainingMaterialsEnabled)
  if (!display) {
    return null
  }

  return <NavbarItem name={f('Training materials')} href={Routes.trainingMaterials} icon={<SchoolOutlined />} />
}

export default TrainingMaterialsTab

